<!--
    description： 组织架构 - 组织管理 - 添加用户
-->
<template>
  <IviewModal
    v-bind="$attrs"
    @on-ok="save"
    @on-cancel="close"
    size="middle2"
    class="add-user"
    @on-visible-change="open"
    :title="ppType == 'add' ? '添加用户' : '编辑用户'"
  >
    <div class="form_container user-content">
      <Form ref="form_container" :model="form" :rules="ruleValidate">
        <FormItem prop="displayName" :label="'姓名'" required>
          <IviewInput v-model="form.displayName" :disabled="!aiShow"></IviewInput>
        </FormItem>

        <FormItem prop="userName" :label="'手机号码'">
          <IviewInput v-model="form.userName" :disabled="!aiShow"></IviewInput>
        </FormItem>

        <FormItem prop="email" :label="'邮箱'">
          <IviewInput v-model="form.email" :disabled="!aiShow"></IviewInput>
        </FormItem>

        <div class="select-organ">
          <div class="title-micro">
            <i></i>
            <span>组织及角色</span>
            <!-- <span>{{ depData.title }}</span> -->
          </div>
          <ul class="organ-list">
            <li v-for="(item, i) in organList" :key="i" class="item">
              <div class="form-item">
                <div class="label">组织</div>
                <IviewSelect
                  v-model="item.parentGroupId"
                  :optionList="organSelect"
                  @on-change="organChange(item, i)"
                  @on-open-change="openOrganSelect"
                  class="select1"
                  placeholder="请选择组织"
                />
              </div>
              <div class="form-item">
                <div class="label">部门</div>
                <!--  checkStrictly: true, -->
                <el-cascader
                  v-model="item.groupId"
                  :options="item.depSelect"
                  :props="{ multiple: true, label: 'title', value: 'id' }"
                  clearable
                  collapse-tags
                  :show-all-levels="false"
                  placeholder="请选择部门"
                ></el-cascader>
              </div>
              <div class="form-item">
                <div class="label">角色</div>
                <Select v-model="item.role" clearable multiple :max-tag-count="5" placeholder="请选择角色">
                  <Option v-for="role in item.roleSelect" :value="role.value" :key="role.value">{{
                    role.label
                  }}</Option>
                </Select>
              </div>
              <span class="img1" @click="addItem(i)" v-if="organList.length < organSelect.length">
                <svg-icon :icon-class="'icon-add'"></svg-icon
              ></span>
              <span class="img2" @click="delItem(i)" v-show="organList.length > 1">
                <svg-icon :icon-class="'icon-del'"></svg-icon
              ></span>
              <!-- <img
                class="img1"
                @click="addItem(i)"
                src="~_img/common/table-add.png"
                alt=""
                v-if="organList.length < organSelect.length"
              /> -->
              <!-- <img
                class="img2"
                @click="delItem(i)"
                v-show="organList.length > 1"
                src="~_img/common/table-del.png"
                alt=""
              /> -->
            </li>
          </ul>
        </div>
      </Form>
    </div>
  </IviewModal>
</template>

<script>
import { checkPhone, checkEmail } from '@/utils/check'
import { transData } from '@/utils'
import { loginMethod } from '@/utils/common'
export default {
  name: 'addUser',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    depData: {
      type: Object,
      default: () => ({})
    },
    ppType: {
      type: String,
      default: 'add'
    }
  },
  inject: ['config'],
  data() {
    return {
      visible: true,
      ruleValidate: {
        displayName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        userName: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback, source, options) => {
              if (value) {
                if (!checkPhone(value)) {
                  callback('手机号有误')
                } else {
                  this.$api.user.getUserAll({ userName: value }).then((res) => {
                    if (res.data.records.length > 0 && !this.form.id) callback('手机号已存在')
                    else callback()
                  })
                }
              } else {
                callback('请输入手机号')
              }
            }
          }
        ],
        email: [
          {
            // required: true,
            trigger: 'blur',
            validator: (rule, value, callback, source, options) => {
              if (value) {
                if (!checkEmail(value)) {
                  callback('邮箱格式错误')
                } else {
                  this.$api.user.checkUser({ email: value }).then((res) => {
                    if (res.data.email && !this.form.id) callback('邮箱已存在')
                    else callback()
                  })
                }
              } else {
                callback()
              }
            }
          }
        ]
      },
      aiShow: true,
      organList: [
        {
          depSelect: [],
          roleSelect: [],
          parentGroupId: '',
          role: [],
          groupId: []
        }
      ],
      depSelect: [],
      organSelect: []
    }
  },
  async created() {
    // 单点登录隐藏按钮
    this.aiShow = await loginMethod(this.$root.platform)
    // 获取组织下拉列表
    await this.$api.config.getOrganSelect().then((res) => {
      this.organSelect = res.data.map((item) => ({
        ...item,
        label: item.groupName,
        value: item.groupId,
        disabled: false
      }))
    })
    this.init()
  },
  methods: {
    init() {
      if (this.ppType == 'add') {
        this.organList[0].parentGroupId = this.depData.id
        this.organChange(this.organList[0])
      } else if (this.ppType == 'edit') {
        this.$api.user.getUserOrgan({ userId: this.form.id }).then((res) => {
          let arr = res.data.map(async (item) => {
            // 获取角色数据
            let res1 = await this.$api.role.getRoleList({ pageCurrent: 1, pageSize: -1 }, [item.groupId])
            let roleSelect = res1.data.records.map((item) => ({ label: item.name, value: item.id }))
            // 获取部门数据
            let res2 = await this.$api.organ.getDepCascade({ groupId: item.groupId, groupType: 2 }, [item.orgLevel])
            let depSelect = transData(res2.data, 'children', (item) => item)
            return {
              depSelect,
              roleSelect,
              parentGroupId: item.groupId,
              role: item.roles.map((item) => item.roleId),
              groupId: item.deptGroups.map((dep) => dep.groupIdPath)
            }
          })
          Promise.all(arr).then((res) => {
            if (res.length != 0) {
              this.organList = res
            } else {
              this.organList = [
                {
                  depSelect: [],
                  roleSelect: [],
                  parentGroupId: '',
                  role: [],
                  groupId: []
                }
              ]
            }
          })
        })
      }
    },
    open(bool) {
      return
      if (bool) {
        if (this.ppType == 'edit') {
          this.$api.user.getUserOrgan({ userId: this.form.id }).then((res) => {
            let arr = res.data.map(async (item) => {
              // console.log('2222',item)
              // 获取角色数据
              let res1 = await this.$api.role.getRoleList({ pageCurrent: 1, pageSize: -1 }, [item.groupId])
              let roleSelect = res1.data.records.map((item) => ({ label: item.name, value: item.id }))
              // 获取部门数据
              let res2 = await this.$api.role.getDepTree({}, [item.groupId])
              // let res2 = await this.$api.organ.getDepCascade({ groupId: item.groupId, groupType: 2 }, [])
              let depSelect = [res2.data].map((item) => ({ ...item }))
              return {
                depSelect,
                roleSelect,
                parentGroupId: item.groupId,
                role: item.roles.map((item) => item.roleId),
                groupId: item.deptGroups.map((dep) => dep.groupIdPath)
              }
            })
            Promise.all(arr).then((res) => {
              if (res.length != 0) {
                this.organList = res
              } else {
                this.organList = [
                  {
                    depSelect: [],
                    roleSelect: [],
                    parentGroupId: '',
                    role: [],
                    groupId: []
                  }
                ]
              }
            })
          })
        } else {
          this.$refs['form_container'].resetFields()
          this.organList = [
            {
              depSelect: [],
              roleSelect: [],
              parentGroupId: '',
              role: [],
              groupId: []
            }
          ]
        }
      }
    },
    // 切换组织
    organChange(item, index) {
      if (!item.parentGroupId) return
      // 获取部门数据
      let data = this.organSelect.find((org) => org.groupId == item.parentGroupId)
      this.$api.organ.getDepCascade({ groupId: data.value, groupType: 2 }, [data.orgLevel]).then((res) => {
        item.depSelect = transData(res.data, 'children', (item) => item)
        item.groupId = []
      })
      // 获取角色数据
      this.$api.role.getRoleList({ pageCurrent: 1, pageSize: -1 }, [item.parentGroupId]).then((res) => {
        item.roleSelect = res.data.records.map((item) => ({ label: item.name, value: item.id }))
        item.role = []
      })
    },
    // 打开组织下拉框时
    openOrganSelect() {
      let arr = this.organList.map((item) => item.parentGroupId)
      this.organSelect.map((item) => {
        item.disabled = arr.includes(item.value)
      })
    },
    // 添加删除输入框项
    addItem(i, val) {
      console.log(i)
      this.organList.splice(i + 1, 0, {
        depSelect: [],
        roleSelect: [],
        parentGroupId: '',
        role: [],
        groupId: []
      })
    },
    delItem(i, val) {
      this.organList.splice(i, 1)
    },
    save() {
      let params = this.organList
        .filter((item) => item.parentGroupId && item.groupId.length > 0)
        .map((item) => {
          return {
            groupId: item.groupId.map((item2) => item2.slice(-1)[0]).join(','),
            parentGroupId: item.parentGroupId,
            role: item.role
          }
        })
      if (params.length == 0 || params.length < this.organList.length) {
        this.$Message.warning('请完善组织与部门信息！');
        return;
      }
      this.$refs['form_container'].validate(async (valid) => {
        if (valid) {
          if (this.ppType == 'add') {
            this.$api.organ
              .addUser({
                belongSystem: 1,
                enable: true,
                ...this.form,
                mobile: this.form.userName
              })
              .then(async (res) => {
                // 设置组织,部门
                await this.$api.user.putUserOrgan(params, [res.data.id])
                // 设置角色
                let roleList = []
                params
                  .filter((item) => item.role.length > 0)
                  .map((item) =>
                    item.role.map((roleId) => {
                      roleList.push({
                        userId: res.data.id,
                        roleId: roleId,
                        userDisplayName: this.form.displayName
                      })
                    })
                  )
                if (roleList.length > 0) {
                  await this.$api.role.setRole1(roleList)
                } else {
                  await this.$api.role.clearRole(roleList, ['roles-coverage?clearRoleUserIds=' + res.data.id])
                }
                this.$Message.success('添加成功')
                this.$emit('refresh')
                this.close()
              })
          } else {
            this.$api.organ
              .putUser({ belongSystem: 1, enable: true, ...this.form, mobile: this.form.userName }, [this.form.id])
              .then(async (res) => {
                // 设置组织,部门
                await this.$api.user.putUserOrgan(params, [res.data.id])
                // 设置角色
                let roleList = []
                params
                  .filter((item) => item.role.length > 0)
                  .map((item) =>
                    item.role.map((roleId) => {
                      roleList.push({
                        userId: res.data.id,
                        roleId: roleId,
                        userDisplayName: this.form.displayName
                      })
                    })
                  )
                if (roleList.length > 0) {
                  await this.$api.role.setRole1(roleList)
                } else {
                  await this.$api.role.clearRole(roleList, ['roles-coverage?clearRoleUserIds=' + res.data.id])
                }
                this.$Message.success('修改成功')
                this.$emit('refresh')
                this.close()
              })
          }
        }
      })
    },
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.add-user {
  .ivu-select {
    width: 266px;
    /deep/.ivu-select-selection {
      background: #f6f8fb;
    }
  }
  /deep/.form_container {
    .ivu-form {
      display: block;
    }
  }
  .user-content {
    margin-left: 30px;
    .select-organ {
      margin: 0 100px 30px;
    }
    .organ-list {
      background: #f6f8fb;
      border: 1px solid #e9edf2;
      padding-bottom: 20px;
      margin-top: 10px;
      .item {
        width: 647px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(201, 208, 228, 0.4), 0px 1px 5px 0px #e1e8f0;
        border-radius: 4px;
        position: relative;
        margin: 20px 0 0 76px;
        padding: 10px 30px 20px;
        .form-item {
          display: flex;
          align-items: center;
          margin: 10px 0;
          font-size: 14px;
          margin-left: 24px;
          .label {
            margin-right: 10px;
          }
        }
        /deep/.el-cascader,
        /deep/.ivu-select {
          width: 500px;

          .el-cascader__tags {
            margin-top: 5px;

            .el-tag {
              background: #fff;
            }
          }
        }
        .select1 {
        }
        .img1,
        .img2 {
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          margin-left: 12px;
          cursor: pointer;
          z-index: 999;
        }
        .img2 {
          right: -52px;
        }
      }
    }
  }
}
</style>
